import React from 'react'
import tw from 'tailwind-styled-components'
import {DivWithHint} from '@components/common/hint/hint'
import {IconTabler} from '@components/common/icon-tabler/icon-tabler'
import {cn} from '@containers/html-utils'
import {IconProps, TwBgProps, TwProps} from '../types'
import {
  getActive,
  getBgForced,
  getBgHover,
  getDefault,
  getForced,
  getHover,
  getSize,
  getSvgSize
} from './icon-button-utils'

type TwIconButtonProps = TwProps & React.ComponentProps<typeof DivWithHint>

const TwIconButton = tw<TwIconButtonProps>(DivWithHint)`
  ${p =>
    cn(
      getSize(p.$size),
      p.$disabled && cn('pointer-events-none', 'text-disabled'),
      !p.$disabled &&
        cn(
          'cursor-pointer',
          getDefault(p.$color),
          getHover(p.$color),
          getActive(p.$color),
          p.$forcedState && getForced(p.$forcedState, p.$color),
          p.$bgStyle && 'relative isolate'
        )
    )}
  select-none
  flex
  items-center
  justify-center
  group/icon-button
`

const TwBackground = tw.div<TwBgProps>`
  -z-10
  absolute
  top-0
  right-0
  bottom-0
  left-0
  rounded-full
  ${p =>
    cn(
      getBgHover(p.$bgStyle),
      p.$forcedState && getBgForced(p.$forcedState, p.$bgStyle)
    )}
`

export const IconButton = React.forwardRef(
  (
    {
      disabled = false,
      color = 'primary',
      size = 'medium',
      wrapperSize = size,
      icon,
      forcedState,
      bgStyle,
      ...props
    }: IconProps,
    ref
  ) => {
    return (
      <TwIconButton
        ref={ref}
        $size={wrapperSize}
        $color={color}
        $disabled={disabled}
        $forcedState={forcedState}
        $bgStyle={bgStyle}
        {...props}
      >
        {bgStyle && !disabled && (
          <TwBackground $bgStyle={bgStyle} $forcedState={forcedState} />
        )}
        <IconTabler
          customSize={getSvgSize(size)}
          icon={icon}
          viewBox="0 0 24 24"
          className="flex-none"
        />
      </TwIconButton>
    )
  }
)
